import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SettingsService } from '../services/settings.service';

export const noAuthGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isAuthenticated()) {
      console.log('User not authenticated, allowing access to login page')
        authService.logout();
        return true;
    }

    // Redirect to dashboard if already authenticated
    router.navigate(['/dashboard']);
    return false;
};
